import React from "react";
import "./privacy-policy.style.scss";

function PrivacyPolicyHR() {
  return (
    <div className="privacy">
      <h1 className="privacy-heading">
        POLITIKA PRIVATNOSTI i OPĆI UVJETI korištenja Platforme sa elektroničkim uslugama za e/m Potpis i e/m-Pečat 
        i mobilne aplikacije mPotpis</h1>
      <h1 className="privacy-heading">
        Ministarstvo pravosuđa, uprave i digitalne transformacije
      </h1>

      <div className="privacy-content">
        <p>Sadržaj</p>

        <ul className="privacy-list">
          <li>
            <a href="#uvod">1. Uvodne odredbe</a>
          </li>
          <li>
            <a href="#definicije">2. Definicije/pojmovi</a>
          </li>
          <li>
            <a href="#opseg">3. Opseg općih uvjeta korištenja</a>
          </li>
          <li>
            <a href="#koristenje">
              4. Korištenje usluge e/m-Pečat e/m-Potpis i e/m-Pečat
            </a>
          </li>
          <li>
            <a href="#privatnost">5. Zaštita privatnosti podataka</a>
          </li>
          <li>
            <a href="#odgovornost">6. Odgovornost</a>
          </li>
          <li>
            <a href="#prituzbe">7. Rješavanje pritužbi</a>
          </li>
          <li>
            <a href="#odredbe">8. Završne odredbe</a>
          </li>
        </ul>

        <p>
        <a href="#prilog1">Prilog 1</a>: Obavijest o zaštiti osobnih podataka u Ministarstvu pravosuđa, uprave i digitalne transformacije za korištenje usluge e/m Potpis i
          e/m-Pečat e/m-Potpis i e/m-Pečat
        </p>
      </div>

      <section id="uvod">
        <h3>1. Uvodne odredbe</h3>
        <p>
          <strong>1.1.</strong> Ovim općim uvjetima korištenja Platforme sa elektroničkim uslugama 
          za e/m Potpis i e/m-Pečat i mobilne aplikacije mPotpis (u daljnjem tekstu Platforma) uređuju 
          se pravila korištenja iste od strane fizičkih osoba ili ovlaštenih zastupnika pravnih osoba. 
          Platforma se sastoji od web i mobilne aplikacije te odgovarajućih API komponenti za integraciju s informacijskim sustavima javnopravnih tijela. 
          Korištenjem Platforme prihvaćate ove Opće uvjete i dajete privolu na obradu osobnih podataka.
        </p>
        <p>
          <strong>1.2.</strong> Prihvaćanjem ovih Općih uvjeta Korisnici su suglasni da će
          Platformu koristiti isključivo u skladu s njihovom izvornom svrhom,
          zakonitom namjenom i na način koji ne ugrožava, ograničava ili
          sprječava rad i korištenje od strane trećih osoba.
        </p>
        <p>
          <strong>1.3.</strong> Opće uvjete korištenja pročitajte pažljivo prije korištenja
          usluge Platforme koju pruža Ministarstvo pravosuđa, uprave i digitalne transformacije.
        </p>
        <p>
          <strong>1.4.</strong> Ovaj akt sadrži pravno obvezujuće odredbe i uvjete potrebne za
          korištenje Platforme. Platforma kreira/ugrađuje kvalificirani
          elektronički potpis koji ima jednak pravni učinak kao vlastoručni
          potpis više dobavljača pružatelja usluga povjerenja sukladno Uredbi
          (EU) br. 910/2014 Europskog parlamenta i Vijeća od 23. srpnja 2014. o
          elektroničkoj identifikaciji i uslugama povjerenja za elektroničke
          transakcije na unutarnjem tržištu i stavljanju izvan snage Direktive
          1999/93/EZ.
        </p>
        <p>
          <strong>1.5.</strong> Sva pitanja ili primjedbe u odnosu na funkcioniranje Platforme
          upućuju se na adresu elektroničke pošte:
          <a href="mailto:potpis.pecat@rdd.gov.hr"> potpis.pecat@rdd.gov.hr</a>
        </p>
        <p>
          <strong>1.6.</strong> Sve zahtjeve ili pitanja u vezi s obradom osobnih podataka kao i
          povlačenje privole na obradu osobnih podataka mogu se podnijeti u
          pisanom obliku na adresu: Ministarstvo pravosuđa, uprave i digitalne transformacije, Ivana Lučića 8, 10000 Zagreb ili elektroničkom poštom na:
          <a href="mailto:zastitapodataka@rdd.hr"> zastitapodataka@rdd.hr</a>
        </p>
        <p>
          <strong>1.7.</strong> Usluga će biti pružena sukladno ovim Općim uvjetima korištenja, a
          rješavanje pritužbi ili izvršenje pravnih zahtjeva od strane Korisnika
          i sukladno Obavijesti o zaštiti privatnosti (vidi Prilog 1.).
          Prihvaćanjem ovih Općih uvjeta korištenja, Korisnik je suglasan s
          prijenosom nekih svojih osobnih i/ili poslovnih podataka u skladu s
          Obavijesti o zaštiti privatnosti koja je sastavni dio Općih uvjeta
          korištenja.
        </p>
        <p>
          <strong>1.8.</strong> Ministarstvo pravosuđa, uprave i digitalne transformacije zadržava
          pravo bez prethodne najave izmijeniti i/ili dopuniti Opće uvjete, o
          čemu će Korisnici/Prekogranični korisnici biti pravovremeno
          obaviješteni
        </p>
        <p><strong>1.9.</strong> Ovi Opći uvjeti primjenjuju se od 20. ožujka 2023. godine.</p>
      </section>

      <section id="definicije">
        <h3>2. Definicije/pojmovi</h3>

        <p>
          <strong>2.1.</strong> „Korisnik” znači fizička osoba ili ovlašteni zastupnika/ca
          pravnih osoba koja koristi Uslugu i koja ima valjani potpisni
          certifikat
        </p>

        <p>
          <strong>2.2.</strong> „Platforma” znači platforma sa elektroničkim uslugama za
          e/m-Potpis i e/m-Pečat Republike Hrvatske kao uspostavljeni zajednički
          dijeljeni servis javne uprave
        </p>

        <p>
          <strong>2.3.</strong> „Pružatelj usluge” je Republika Hrvatska, Ministarstvo pravosuđa, uprave i digitalne transformacije
        </p>

        <p>
          <strong>2.4.</strong> podržana sredstva za izradu kvalificiranog elektroničkog potpisa
          i kvalificiranog elektroničkog pečata su sva sredstva koja ispunjavaju
          uvjete propisane za kvalificirane certifikate sukladno Uredbi (EU) br.
          910/2014 Europskog parlamenta i Vijeća od 23. srpnja 2014. o
          elektroničkoj identifikaciji i uslugama povjerenja za elektroničke
          transakcije na unutarnjem tržištu i stavljanju izvan snage Direktive
          1999/93/EZ.
        </p>
      </section>

      <section id="opseg">
        <h3>3. Opseg općih uvjeta korištenja</h3>

        <p>
          <strong>3.1.</strong> Platformu može koristiti samo Korisnik koji ima valjani
          kvalificirani elektronički potpis i kvalificirani elektronički pečat
          sukladno uvjetima propisanim za kvalificirane certifikate sukladno
          Uredbi (EU) br. 910/2014 Europskog parlamenta i Vijeća od 23. srpnja
          2014. o elektroničkoj identifikaciji i uslugama povjerenja za
          elektroničke transakcije na unutarnjem tržištu i stavljanju izvan
          snage Direktive 1999/93/EZ. Korištenje Platforme od strane fizičkih
          osoba koje ne ispunjavaju navedeni uvjet nije ovlašteno i smatra se
          povredom ovih Općih uvjeta korištenja
        </p>

        <p>
          <strong>3.2.</strong> Opći uvjeti korištenja stupaju na snagu od datuma navedenog pod
          naslovom, do ukidanja.
        </p>

        <p>
          <strong>3.3.</strong> Republika Hrvatska, Ministarstvo pravosuđa, uprave i digitalne transformacije zadržava pravo promijeniti način i okolnosti rada Platforme u
          skladu s odredbama koje se primjenjuju na izmjene Općih uvjeta
          korištenja te prestati pružati ili ograničiti rad Platforme.
        </p>

        <p>
          <strong>3.4.</strong> Ako bilo koja odredba Općih uvjeta korištenja bude ili postane
          nevažeća ili neprovediva, to neće utjecati na valjanost preostalih
          odredbi.
        </p>

        <p>
          <strong>3.5.</strong> Ako se ovi Opći uvjeti korištenja izmijene, Pružatelj usluge
          dužan je objaviti: činjenicu izmjene, datum stupanja na snagu izmjene
          te sastaviti novi tekst Općih uvjeta korištenja koji je na snazi od
          toga datuma i to na Internetskoj stranici i učiniti ga dostupnim od
          datuma stupanja na snagu izmjene.
        </p>

        <p>
          <strong>3.6.</strong> Ako Korisnik nastavi koristiti Platformu nakon datuma stupanja na
          snagu izmjene Općih uvjeta korištenja, smatra se da je Korisnik
          prihvatio nove Opće uvjete korištenja s izmijenjenim sadržajem.
        </p>
      </section>

      <section id="koristenje">
        <h3>4. Korištenje platforme</h3>
        <p>
          <strong>4.1.</strong> Korištenje platforme podložno je suglasnosti s ovim Općim
          uvjetima korištenja i poštivanju odredbi sadržanih u njima.
        </p>

        <p>
          <strong>4.2.</strong> Pružatelj usluge može privremeno prekinuti pružanje usluge
          tijekom razdoblja izvođenja potrebnih radova održavanja.
        </p>

        <p>
          <strong>4.3.</strong> Pružatelj usluge može odbiti pružanje usluge i može prekinuti
          pružanje usluge Korisniku s trenutačnim učinkom ako to zahtijeva zakon
          ili službena/sudska odluka ili ako se Platforma koristi protivno Općim
          uvjetima korištenja ili na koji drugi način protupravno ili
          nepropisno, uzimajući u obzir svrhu usluge.
        </p>

        <p>
          <strong>4.4.</strong> Prilikom izrade elektroničkog potpisa dokumenta, sam korisnik
          određuje uključuje li elektronički potpis dokumenta vizualni prikaz
          elektroničkog potpisa odnosno pečata na dokumentu ili ga ne uključuje.
          Sukladno pravnoj regulativi, vizualni prikaz elektroničkog potpisa
          i/ili pečata ne predstavlja i nema svojstva samog elektroničkog
          potpisa i/ili pečata.
        </p>

        <div>
          <p><strong>4.5.</strong> Tehnički uvjeti za korištenje usluge Platforme: </p>
          <p>
            Za korištenje Platforme Korisnik mora osigurati sljedeće tehničke
            uvjete:
          </p>

          <ul>
            <li>
              osobno računalo s Windows (verzija 7 ili viša) ili Linux (Ubuntu
              16.04.2 ili viša) operativnim sustavom i instaliranom
              odgovarajućom programskom podrškom koju osigurava odabrani
              davatelj usluge povjerenja čijim certifikatom korisnik potpisuje
              dokumente na Platformi
            </li>
            <li>pristup internetu</li>
            <li>
              čitač pametnih kartica, integriran ili vanjski USB s minimalnim
              specifikacijama:
              <ul>
                <li>ISO7816</li>
                <li>sukladnost PC/SC</li>
                <li>odgovarajući driver za operativni sustav računala</li>
                <li>USB 2.0.</li>
              </ul>
            </li>
            <li>
              instaliran jedan od sljedećih Internet preglednika:
              <ul>
                <li>Google Chrome - verzije 43 i više</li>
                <li>Internet Explorer - verzije 11 i više</li>
                <li>Opera - verzije 30 i više</li>
                <li>Firefox – verzije 41 i više</li>
              </ul>
            </li>
            <li>
              unutar odabranog Internet preglednika treba biti omogućeno:
              <ul>
                <li>skočni prozori</li>
                <li>izvršavanje JavaScript koda</li>
                <li>
                  komunikacija s lokalnim servisima sredstva za potpisivanje
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <p>
          <strong>4.6.</strong> Republika Hrvatska, Ministarstvo pravosuđa, uprave i digitalne transformacije ne snosi odgovornost u slučaju nemogućnosti korištenja
          Platforme zbog neodgovarajućeg postupanja Korisnika.
        </p>

        <p>
          <strong>4.7.</strong> Republika Hrvatska, Ministarstvo pravosuđa, uprave i digitalne transformacije ne odgovara za nedostupnost Platforme nastalih kao posljedica
          tehničkih problema ili više sile.
        </p>

        <p><strong>4.8.</strong> Postupak pružanja usluge</p>

        <p>
          <strong>4.8.1.</strong> Korisnik pristupa Platformi te potvrđuje svoju namjeru
          elektroničkog potpisivanja ili pečatiranja tog dokumenta klikom na
          gumb na grafičkom sučelju Platforme. Pri tome Platforma ne ulazi u
          sadržaj dokumenta niti provjerava pravne ovlasti za potpisivanje
          dokumenta, što je isključiva odgovornost Korisnika.
        </p>

        <p>
          <strong>4.8.2.</strong> Nakon toga se generira sažetak (hash) Korisnikovog dokumenta te
          se dokument priprema za potpis.
        </p>

        <p>
          <strong>4.8.3.</strong> Nakon što Korisnik unese ispravan PIN potpisnog certifikata
          kojeg posjeduje odnosno nakon šte uspješno izvrši radnje autentikacije
          (ukoliko Platformi pristupa u sustavu e-Građani) Platforma kreira
          digitalno potpisani dokument te ga Korisnik može preuzeti.
        </p>
      </section>

      <section id="privatnost">
        <h3>5. Zaštita privatnosti podataka</h3>

        <p>
          <strong>5.1.</strong> Detaljne odredbe koje se odnose na obradu Korisnikovih podataka i
          Obavijest o zaštiti osobnih podatka navedene su u Prilogu 1.
        </p>
        <p>
          <strong>5.2.</strong> Pružatelj usluga obrađuje podatke koje je Korisnik stavio na
          raspolaganje u skladu s važećim zakonima i propisima, kako onima iz
          EU-a, posebice Uredbom (EU) 2016/679 Europskog parlamenta i Vijeća od
          27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih
          podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan
          snage Direktive 95/46/EZ (Opća uredba o zaštiti podataka, dalje u
          tekstu: GDPR) tako i hrvatskim.
        </p>
      </section>

      <section id="odgovornost">
        <h3>6. Odgovornost</h3>
        <p><strong>6.1.</strong> Odgovornost vlasnika Platforme</p>
        <p>
          <strong>6.1.1.</strong> Vlasnik Platforme neće biti odgovoran ni za kakve posljedice
          koje proizlaze iz povreda odredbi ovih Općih uvjeta korištenja od
          strane Korisnika, uključujući, ali ne ograničavajući se na događaje
          koji mogu biti povezani s nepravilnom upotrebom Platforme od strane
          Korisnika, ponašanjem ili povredom pravila od strane Korisnika itd.,
          koje je Korisnik prihvatio.
        </p>
        <p>
          <strong>6.1.2.</strong> Odgovornost vlasnika Platforme bit će ograničena na odgovornost
          za ponašanje i za štetu uzrokovanu namjernim ponašanjem vlasnika
          Platforme. Osim navedenog, vlasnik Platforme neće biti odgovoran ni za
          kakvu izravnu ili neizravnu štetu koja proizlazi iz korištenja
          Platforme, uključujući, ali ne ograničavajući se na izgubljenu dobit i
          posljedičnu štetu.
        </p>
        <p>
          <strong>6.1.3.</strong> Vlasnik Platforme nije obvezan snositi ili nadoknaditi štetu
          koja se može pripisati okolnostima izvan njegove kontrole.
        </p>

        <p>
          <strong>6.1.4.</strong> Vlasnik Platforme se ne može smatrati odgovornim za tehničke
          smetnje, uključujući, ali ne ograničavajući se na bilo kakve zastoje u
          električnim, internetskim ili računalnim mrežama.
        </p>

        <p>
          <strong>6.1.5.</strong> Vlasnik Platforme neće preuzeti odgovornost ni za kakvu štetu
          nastalu korištenjem, nepravilnim radom ili brisanjem bilo kojeg dijela
          ili sadržaja internetske stranice.
        </p>

        <p><strong>6.2.</strong> Odgovornost korisnika</p>

        <p>
          <strong>6.2.1.</strong> Korisnici su obvezni snositi ili nadoknaditi svu štetu koja
          nastane zbog kršenja zahtjeva navedenih u Općim uvjetima korištenja.
        </p>
        <p>
          <strong>6.2.2.</strong> Korisnici će biti oslobođeni odgovornosti ako dokažu da je
          povreda Općih uvjeta korištenja uzrokovana okolnostima izvan njihove
          kontrole koje se nisu mogle predvidjeti u prihvaćanja istih te se od
          njih ne može očekivati da će izbjeći tu okolnost ili spriječiti štetu.
        </p>

        <p>Korisnici su posebice odgovorni za sljedeće:</p>

        <p>
          <strong>6.2.3.</strong> Korisnik preuzima odgovornost i jamči da koristi uslugu samo s
          podržanim sredstvima za izradu kvalificiranog elektroničkog potpis
          koji su u skladu s važećim zakonima, propisima i standardima koji se
          primjenjuju na pružanje usluga povjerenja. Korisnik je odgovoran za
          svu štetu nastalu korištenjem usluge s neprikladnim sredstvima za
          izradu kvalificiranog elektroničkog potpisa.
        </p>

        <p>
          <strong>6.2.4.</strong> Preduvjet za korištenje usluge je da Korisnici ne smiju
          koristiti Platformu u svrhe koje su različite od onih utvrđenih u ovim
          Općim uvjetima korištenja i zakonodavstvu. Korisnici mogu koristiti
          Platformu samo osobno ili ako su na to ovlašteni. Korisnici su
          odgovorni za sve aktivnosti vezane uz korištenje Platforme.
        </p>
      </section>

      <section id="prituzbe">
        <h3>7. Rješavanje pritužbi</h3>

        <p>
          <strong>7.1.</strong> Korisnici mogu podnijeti pritužbu putem e-mail adrese{" "}
          <a href="mailto:potpis.pecat@rdd.gov.hr">potpis.pecat@rdd.gov.hr</a>
        </p>

        <p>
          <strong>7.2.</strong> Vlasnik Platforme šalje odgovor u vezi s osnovanošću pritužbe
          Korisniku putem kontakta koji je Korisnik naveo u pritužbi u roku od
          trideset (30) dana. Pružatelj usluga mora navesti razloge za odluke o
          odbijanju prigovora.
        </p>

        <p>
          <strong>7.3.</strong> Vlasnik Platforme mora čuvati pritužbu i kopiju odgovora u vezi s
          osnovanošću pritužbe
        </p>
      </section>

      <section id="odredbe">
        <h3>8. Završne odredbe </h3>

        <p><strong>8.1.</strong> Viša sila</p>

        <p>
          Ne predstavlja povredu ako bilo koja od strana nije u mogućnosti
          izvršiti svoje obveze navedene u ovim Općim uvjetima korištenja iz
          bilo kojeg razloga koji se ne može pripisati niti jednoj od strana
          (viša sila). Događaj više sile uključuje sve nepredviđene događaje
          koje čovjek ne može spriječiti (npr. rat, potres, poplava, požar,
          teroristički čin itd.), a koji ne ovise o volji Strana i izravno
          ometaju određenu Stranu u ispunjenju njezine sporazumne obveze.
        </p>

        <p>Ugovorni rokovi produljuju se za vrijeme trajanja više sile.</p>

        <p>
          Vlasnik Platforme o prijetnji ili pojavi događaja više sile i njegovom
          predviđenom trajanju obavještava putem vlasnika Platforme, ali vlasnik
          Platforme nije odgovoran i ne utječe na pružanje usluga koju daje
          pružatelj Usluga povjerenja.
        </p>

        <p>
          <strong>8.2.</strong> Strane su suglasne da će se sva pitanja regulirana ovim Općim
          uvjetima korištenja rješavati primjenom pravila hrvatskoga prava.
        </p>

        <p>
          <strong>8.3.</strong> Strane će nastojati riješiti sve sporove vezane uz korištenje
          Platforme mirnim putem. Sporovi koji se ne mogu riješiti mirnim putem,
          rješavat će se pred nadležnim sudom u Zagrebu koji je mjesno nadležan.
        </p>

        <p><strong>8.4.</strong> Prilog 1. čini neodvojivi dio Općih uvjeta korištenja.</p>
      </section>

      <section id="prilog1">
        <h3>Prilog 1.</h3>
        <h4>INFORMACIJE O OBRADI OSOBNIH PODATAKA</h4>
        <h4>VODITELJ OBRADE</h4>
        <p>
          Ministarstvo pravosuđa, uprave i digitalne transformacije, Ivana Lučića 8,
          10000 Zagreb
        </p>
        <h4>
          PODACI KOJI SE PRIKUPLJAJU, SVRHA I ZAKONITOST PRIKUPLJANJA I OBRADE
        </h4>
        <p>
          Osobne podatke prikupljamo i obrađujemo u svrhu izvršavanja zadaća od
          javnog interesa i naših službenih ovlasti te radi poštivanja pravnih
          obveza u skladu sa zakonom ili drugim propisom Republike Hrvatske i
          pravom Europske unije. To uključuje:
        </p>
        <ul>
          <li>
            obrade osobnih podataka kako bi vam omogućili korištenje Nacionalnog
            identifikacijskog i autentifikacijskog sustava (NIAS) i
            elektroničkih vjerodajnica i certifikata sukladno Uredbi eIDAS
          </li>
          <li>
            obrade osobnih podataka kako bi vam omogućili pružanje e-usluga
          </li>
          <li>
            obrade osobnih podataka radi davanja odgovora na postavljeni upit
          </li>
        </ul>

        <p>Navedene obrade mogu uključivati sljedeće kategorije podataka:</p>
        <ul>
          <li>osobne identifikacijske informacije korisnika</li>
        </ul>

        <p>Prikupljanje i obrada osobnih podataka zakonito je temeljem:</p>
        <ul>
          <li>
            članka 6. stavka 1 točke (c) obrada je nužna radi poštovanja pravnih
            obveza
          </li>
          <li>
            članka 6. stavka 1 točke (e) obrada je nužna za izvršavanje zadaće
            od javnog interesa ili pri izvršavanju službene ovlasti voditelja
            obrade UREDBE (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27.
            travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka
            i o slobodnom kretanju takvih podataka te o stavljanju izvan snage
            Direktive 95/46/EZ.{" "}
          </li>
        </ul>

        <h4>LEGITIMNI INTERESI</h4>
        <p>
          Voditelj obrade ima legitimni interes prikupljati vaše osobne podatke
          u svrhu poboljšanja funkcioniranja i unaprjeđenja Platforme u
          statističke svrhe. U tu svrhu možemo dodatno prikupljati vaša
          mišljenja, komentare ili prijedloge te e-mail adresu radi pružanja
          odgovora.
        </p>
        <p>Prikupljanje i obrada osobnih podataka zakonito je temeljem: </p>
        <ul>
          <li>
            članka 6. stavka 1 točke (f) legitimni interesi voditelja obrade ili
            trećih strana UREDBE (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od
            27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih
            podataka i o slobodnom kretanju takvih podataka te o stavljanju
            izvan snage Direktive 95/46/EZ. Možete podnijeti prigovor ili
            ograničiti obradu. U slučaju uskrate pružanja podataka nećete imati
            negativne posljedice.
          </li>
        </ul>

        <h4>KORIŠTENJE KOLAČIĆA</h4>
        <p>
          U određenim okolnostima možemo prikupljati i obrađivati osobne podatke
          na temelju vašeg prethodnog pristanka. Takvu obradu provodimo onda
          kada prikupljamo „kolačiće“ u svrhu poboljšanja rada sustava te radi
          poboljšanja vašeg korisničkog iskustva. U svakom trenutku svoj
          pristanak možete povući i zaustaviti daljnju obradu bez negativnih
          posljedica.
        </p>

        <p>
          Navedeno prikupljanje i obrada osobnih podataka zakonito je temeljem:
        </p>
        <ul>
          <li>
            članka 6. stavka 1 točke (a) ispitanik je dao privolu za obradu
            svojih osobnih podataka u jednu ili više posebnih svrha{" "}
          </li>
        </ul>
        <p>
          UREDBE (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27. travnja
          2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka i o
          slobodnom kretanju takvih podataka te o stavljanju izvan snage
          Direktive 95/46/EZ. Detaljnije informacije o korištenju kolačića
          možete pročitati na poveznici: (Uporaba kolačića)
        </p>

        <h4>PRIMATELJI OSOBNIH PODATAKA</h4>
        <p>
          Voditelji obrade: podaci koje nam dostavite ne prosljeđujemo drugim
          voditeljima obrade i ne otkrivamo trećim stranama osim u određenim
          okolnostima kad nas na to obvezuju relevantni propisi u opsegu koji je
          potreban za ostvarenje utvrđene svrhe
        </p>
        <p>
          Izvršitelji obrade: možemo proslijediti osobne podatke na korištenje
          pružateljima informatičkokomunikacijskih rješenja i usluga koji
          djeluju kao ugovoreni izvršitelji obrade. U tom slučaju izvršitelj
          obrade obrađuje osobne podatke samo prema našem nalogu, u naše ime, u
          cilju ispunjenja svrhe za koju su osobni podaci prikupljeni te na
          način kako je to utvrđeno međusobnim sporazumom a u skladu sa
          zahtjevima Opće uredbe. To mogu biti sljedeći izvršitelji obrade:
        </p>
        <ul>
          <li>
            Agencija za komercijalnu djelatnost proizvodno, uslužno i trgovačko
            d.o.o., Savska cesta 31, 10 000 Zagreb
          </li>
          <li>Financijska agencija, Ulica grada Vukovara 70, 10000 Zagreb</li>
        </ul>

        <h4>DRUGE STRANICE I LINKOVI</h4>
        <p>
          Kada korištenjem stranice za korištenje Platforme slijedite vezu do
          usluge koju pruža pojedino ministarstvo, državna upravna organizacija,
          agencija, ured i drugo tijelo ili ustanova tada će ta organizacija
          biti samostalni voditelj obrade i odgovorna za podatke koje s njima
          dijelite. Primjenjivat će vlastita pravila privatnosti i pružati svoju
          obavijest o obradi osobnih podataka.
        </p>
        <p>
          Primjerice, kada želite podnijeti e-Zahtjev za izdavanje putovnice bit
          ćete preusmjereni na stranicu pružatelja te usluge{" "}
          <a
            href="https://eputovnica.mup.hr"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://eputovnica.mup.hr
          </a>
          . Ta stranica imat će svoja pravila privatnosti putem kojih ćete
          dobiti obavijesti o obradi vaših osobnih podataka u svezi s traženom
          uslugom te pružiti vam informacije o načinu ostvarivanja Vaših prava.
          Zato je prije korištenja pojedine usluge preporuka upoznati se s
          pravilima privatnosti pružatelja usluge.
        </p>

        <h4>RAZDOBLJE ČUVANJA OSOBNIH PODATAKA</h4>
        <p>
          Prikupljene osobne podatke obrađujemo dok se ne ispuni svrha
          prikupljanja osobnih podataka. Nakon ispunjenja svrhe u koju su podaci
          prikupljeni podaci se više ne koriste i pohranjuju se u sustavima
          pohrane voditelja obrade gdje se čuvaju u skladu sa zakonskim
          propisima o čuvanju arhivske građe.
        </p>
        <h4>VAŠA PRAVA U VEZI S OBRADOM OSOBNIH PODATAKA</h4>
        <p>Imate pravo zahtijevati:</p>
        <ul>
          <li>
            informacije o tome kako se obrađuju vaši osobni podaci: možete
            zatražiti detaljne informacije osobito o njihovoj svrsi obrade, o
            vrsti/kategorijama osobnih podataka koji se obrađuju uključujući i
            uvid u svoje osobne podatke, o primateljima ili kategorijama
            primatelja te o predviđenom razdoblju u kojem će osobni podaci biti
            pohranjeni
          </li>
          <li>
            kopiju osobnih podataka: osigurava se kopija osobnih podataka koji
            se o vama obrađuju. Za dodatne kopije može se naplatiti naknada na
            temelju administrativnih troškova
          </li>
          <li>
            spravak netočnih podataka: imate pravo zatražiti ispravak ili dopunu
            osobnih podataka ako vaši podaci nisu točni, potpuni i ažurni
          </li>
        </ul>

        <p>Također, možete:</p>

        <ul>
          <li>
            uložiti prigovor na način na koji se vaši osobni podaci obrađuju
          </li>
          <li>zatražiti brisanje vaših osobnih podataka</li>
          <li>
            zatražiti da je obrada vaših osobnih podataka ograničena u određenim
            okolnostima
          </li>
          <li>
            zatražiti brisanje vaših osobnih podataka:
            <ul>
              <li>pravo nije primjenjivo u mjeri u kojoj je obrada nužna</li>
              <li>
                radi ostvarivanja prava na slobodu izražavanja i informiranja
              </li>
              <li>
                radi poštovanja pravne obveze kojom se zahtijeva obrada u pravu
                Unije ili pravu Republike Hrvatske ili za izvršavanje zadaće od
                javnog interesa ili pri izvršavanju službene ovlasti voditelja
                obrade
              </li>
              <li>
                u svrhe arhiviranja u javnom interesu, u svrhe znanstvenog ili
                povijesnog istraživanja ili u statističke svrhe u mjeri u kojoj
                je vjerojatno da se ostvarivanjem prava može onemogućiti ili
                ozbiljno ugroziti postizanje ciljeva te obrade
              </li>
              <li>
                radi postavljanja, ostvarivanja ili obrane pravnih zahtjeva.
              </li>
            </ul>
          </li>
        </ul>
        <p>
          O podnijetom zahtjevu obavijestit ćemo vas u roku od 30 dana
          uobičajenim elektroničkim putem osim ako zatražite drugačije.
        </p>

        <h4>SIGURNOST OBRADE</h4>
        <p>
          Osobne podatke prikupljamo i obrađujemo na način kojim se osigurava
          odgovarajuća razina sigurnosti i visok stupanj povjerljivost u
          njihovoj obradi osiguravajući učinkovitu primjenu načela zaštite
          podataka, uključujući zaštitu od neovlaštene ili nezakonite obrade te
          od slučajnog gubitka, uništenja ili oštećenja primjenom odgovarajućih
          tehničkih i organizacijskih mjera zaštite.
        </p>

        <h4>KONTAKTI</h4>
        <p>
          Za pitanja u vezi s prikupljanjem i obradom osobnih podataka putem
          sustava e-Građani ili radi ostvarivanja vaših prava, možete se
          obratiti:
        </p>
        <ul>
          <li>
            Središnjem državnom uredu za razvoj digitalnog društva, Ivana Lučića
            8, 10000 Zagreb
          </li>
          <li>
            Službeniku za zaštitu podataka: e-pošta:{" "}
            <a href="mailto:zastitapodataka@rdd.hr">zastitapodataka@rdd.hr</a>,
            tel.: <a href="tel:+38514400840">+385 1 44 00 840</a>
          </li>
        </ul>

        <p>
          U slučaju kada smatrate da je došlo do povrede vaših osobnih podataka
          možete podnijeti prigovor nadzornom tijelu:
        </p>
        <ul>
          <li>
            Agencija za zaštitu osobnih podataka,{" "}
            <a href="https://azop.hr" target="_blank" rel="noopener noreferrer">
              https://azop.hr
            </a>
            , Selska cesta 136, Zagreb,
          </li>
        </ul>

        <h4>OBAVIJEST O PROMJENAMA PRAVILA PRIVATNOSTI</h4>
        <p>
          Politiku privatnosti redovito ažuriramo pa iz tog razloga može doći i
          do nužne promjene sadržaja. O svim izmjenama i dopunama bit ćete
          pravodobno informirani putem ove internetske stranice.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicyHR;
